import { checkKycDocument } from "api/graphQL_customers";
import DivLoader from "components/divloader/DivLoader";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const ViewKycFile = () => {
    const [initialLoading, setInitialLoading] = useState(true);
    const [documentData, setDocumentData] = useState(null);
    let urlParms = useParams();
    const { kyc_id } = urlParms;
    const fetchLinkData = async() => {
        setInitialLoading(true)
        const checkLinkResponse = await checkKycDocument(kyc_id);
        const resData = checkLinkResponse.data;
        const base64 = resData?.document;
        setDocumentData(base64)     
        setInitialLoading(false)
    }
    useEffect(() => {
        if(kyc_id) {
            fetchLinkData();
        }
    },[kyc_id])

    return (
        <>
            {initialLoading ? (
                <div className="flex items-center justify-center min-h-screen bg-gray-50 px-4">
                    <div className="text-center">
                        <DivLoader className="m-5 h-8 w-8 border-indigo-500" />
                        <p className="text-gray-600">Loading document, please wait...</p>
                    </div>
                </div>
            ) : (
                <iframe
                src={documentData}
                style={{ width: "100%", height: "100vh" }}
                title="KYC Document"
                />
            )}
        </>
    );
};

export default ViewKycFile;
